import type { SVGProps } from 'react';

const SvgTasksCanceled = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentcolor"
      d="M9.71 5.225a.996.996 0 0 0-1.41 0l-1.29 1.29-1.3-1.29a1.003 1.003 0 0 0-1.42 1.42l1.29 1.29-1.29 1.29a.996.996 0 0 0 0 1.41c.2.2.45.29.71.29s.51-.1.71-.29L7 9.345l1.29 1.29c.2.2.45.29.71.29s.51-.1.71-.29a.996.996 0 0 0 0-1.41l-1.29-1.29 1.29-1.29a.996.996 0 0 0 0-1.41zm0 8a.996.996 0 0 0-1.41 0l-1.29 1.29-1.29-1.29a.996.996 0 1 0-1.41 1.41l1.29 1.29-1.29 1.29a.996.996 0 0 0 0 1.41c.2.2.45.29.71.29s.51-.1.71-.29l1.29-1.29 1.29 1.29c.2.2.45.29.71.29s.51-.1.71-.29a.996.996 0 0 0 0-1.41l-1.29-1.29 1.29-1.29a.996.996 0 0 0 0-1.41zM14 8.935h6c.55 0 1-.45 1-1s-.45-1-1-1h-6c-.55 0-1 .45-1 1s.45 1 1 1m6 6h-6c-.55 0-1 .45-1 1s.45 1 1 1h6c.55 0 1-.45 1-1s-.45-1-1-1"
    />
  </svg>
);
export default SvgTasksCanceled;
